import { useEffect, useState } from "react";
import { fetchAuthSession } from "aws-amplify/auth";
import { Admin } from "./Admin/Admin";
import { Subscriber } from "./Subscriber/Subscriber";
import { Referrer } from "./Referrer/Referrer";

export function Login({ user, signOut }) {

    const [userRole, setUserRole] = useState(null); // 'admin', 'referrer', or 'professional'
    const [idToken, setIdToken] = useState(null);
    const [username, setUsername] = useState("");

    const handleSignOut = async () => {
        await signOut({global: true});
    }

    useEffect(() => {
        async function fetchData() {
            const session = await fetchAuthSession();
            const groups = session.tokens?.idToken?.payload["cognito:groups"] || [];

            if (groups.includes("Admin_Group")) {
                setUserRole("admin");
            } else if (groups.includes("Professional_Group")) {
                setUserRole("professional");
            } else {
                setUserRole("referrer");
            }

            setIdToken(session.tokens.accessToken.toString());
            setUsername(user.signInDetails.loginId);
        }
        fetchData();
    }, [user]);

    if (userRole === "admin") {
        return (
            <Admin
                idToken={idToken}
                username={username}
                onSignOut={handleSignOut}
            />
        );
    }

    if (userRole === "referrer") {
        return (
            <Referrer
                idToken={idToken}
                username={username}
                onSignOut={handleSignOut}
            />
        );
    }

    if (userRole === "professional") {
        return <Subscriber idToken={idToken} username={username} onSignOut={handleSignOut} />;
    }

    return null;
}
